import axios from 'axios';
import API_BASE_URL from '../config/api';

const BASE_URL = API_BASE_URL;

export const getSampleTestRecords = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.search) query.append('search', params.search);
  if (params.fromDate) query.append('from_date', params.fromDate);
  if (params.toDate) query.append('to_date', params.toDate);
  if (params.dateField) query.append('date_field', params.dateField);
  if (params.page) query.append('page', params.page);
  if (params.perPage) query.append('per_page', params.perPage);

  const response = await axios.get(`${BASE_URL}/sample-test-records?${query.toString()}`);
  return response.data;
};

export const getSampleTestRecordById = async (registerId) => {
  const response = await axios.get(`${BASE_URL}/sample-test-records/${registerId}`);
  return response.data;
};

export const createSampleTestRecord = async (payload) => {
  const response = await axios.post(`${BASE_URL}/sample-test-records`, payload);
  return response.data;
};

export const updateSampleTestRecord = async (registerId, payload) => {
  const response = await axios.put(`${BASE_URL}/sample-test-records/${registerId}`, payload);
  return response.data;
};

export const deleteSampleTestRecord = async (registerId) => {
  const response = await axios.delete(`${BASE_URL}/sample-test-records/${registerId}`);
  return response.data;
};

export const deleteSampleTestRecordLine = async (lineId) => {
  const response = await axios.delete(`${BASE_URL}/sample-test-records/lines/${lineId}`);
  return response.data;
};
